import PendingInvoices from './components/PendingInvoices';

import PageHeaderLayout from '../shared/components/PageHeaderLayout';
import withSysUtilsFeatureFlagCheck from '../shared/hoc/withSysUtilsFeatureFlagCheck';

const pageConfig = {
  header: 'Payment Utilities',
  description:
    'These utilities are used to manage and simulate payments on the platform.',
};

const PaymentUtils = () => {
  return (
    <PageHeaderLayout pageConfig={pageConfig}>
      <PendingInvoices />
    </PageHeaderLayout>
  );
};

export default withSysUtilsFeatureFlagCheck(PaymentUtils);
